import { combineReducers } from 'redux';

const ASYNC_ACTION_REGEX = /_(STARTED|SUCCESS|ERROR)$/;

const asyncReducer = (state = {}, action) => {
  if (!action.meta || !action.meta.__abyss_async__) {
    return state;
  }

  const key = action.type.replace(ASYNC_ACTION_REGEX, '');

  return {
    ...state,
    [key]: {
      ...state[key],
      ...action.meta.__abyss_async__,
    },
  };
};

export const createRootReducer = (reducers) => {
  return combineReducers({
    ...reducers,
    async: asyncReducer,
  });
};
